import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 145px 48px;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.space["space-2"]};
`;

export const Stats = styled.div`
  display: grid;
  grid-template-columns: 15px 88px 35px 1fr;
  gap: ${({ theme }) => theme.space["space-3"]};
  align-items: center;
`;

export const TagWrapper = styled.div`
  justify-self: flex-end;
`;

export const ContainerPosition = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space["space-1"]};
  width: 145px;
  height: 18px;

  > p:first-child {
    min-width: 50px;
  }
`;

export const ExtraInfo = styled.div<{
  showDefault: boolean;
}>`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ showDefault, theme }) =>
    showDefault
      ? theme.colorTokens.content.subtle
      : theme.colorTokens.content.brandPrimary};
  line-height: ${({ theme }) => theme.lineHeights.s};

  @media screen and ${breakpoints.tablet.min.sm} {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: ${({ theme }) => theme.space["space-1"]};

    > div {
      white-space: inherit;
    }
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    span {
      margin: 0 2px;
      color: ${({ theme }) => theme.colorTokens.content.subtle3};
    }
  }
`;

export const MobileCord = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.space["space-4"]};
  border-top: 1px solid ${({ theme }) => theme.colorTokens.border.default};

  &:active {
    background-color: ${({ theme }) =>
      theme.colorTokens.component.button.buttonLink.background.active};
  }
`;

export const MobileCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MobileHeaderCol = styled.div`
  display: flex;
  align-items: center;
`;

export const MobileCardContent = styled.div`
  display: flex;
  flex-direction: column;
`;
